<template>
  <section>
    <h3>
      Shelters
    </h3>
    <router-link :to="{name: 'ShelterStatus'}">
      <b-button>
        <b-icon
          icon="chevron-double-left">
        </b-icon>
        Shelter Status
      </b-button>
    </router-link>
    <router-link :to="{name: 'Shelter:Create'}">
      <b-button>
        <b-icon
          icon="plus">
        </b-icon>
        Create
      </b-button>
    </router-link>
    <b-table
        :data="statuses"
        :columns="columns">
    </b-table>
  </section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'ShelterList',
  data() {
    return {
      columns: [
        {
          field: 'shelterCode',
          label: 'Shelter Code',
          searchable: true,
        },
        {
          field: 'occupancyStatus',
          label: 'Status',
          searchable: true,
        },
        {
          field: 'time',
          label: 'Report Date',
          searchable: true,
        },
        {
          field: 'numOfRefugees',
          label: 'Number of Refugees',
          searchable: true,
        }
      ]
    }
  },
  mounted () {
    this.fetch()
  },
  computed: {
    ...mapGetters('ShelterStatus', ['statuses'])
  },
  methods: {
    ...mapActions('ShelterStatus', ['fetch'])
  }
}
</script>
